import { AppRouter } from "./app/router/AppRouter";
import { ErrorBoundary } from "./app/ErrorBoundary";

/**
 * Root App component.
 *
 * Keeps App.tsx minimal and delegates routing/auth/layout to `AppRouter`.
 */
export default function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen w-full bg-[color:var(--kkp-bg)] text-[color:var(--kkp-text)]">
        <AppRouter />
      </div>
    </ErrorBoundary>
  );
}
